import styled from 'styled-components';

import colors from '@utils/colors';
import fonts, { weights } from '@utils/fonts';
import { H_PADDING_MOBILE } from '@utils/space';
import { Heading as UnstyledHeading } from '@components/type';

export const CloseButton = styled.button`
  display: flex;
  align-items: center;
  justify-content: center;
  height: 32px;
  width: 32px;
  margin-right: -8px;
  padding: 0;
  background: transparent;
  border: 0;
  border-radius: 6px;
  appearance: none;
  outline: 0;
`;

export const Drawer = styled.div`
  position: fixed;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  z-index: 9999;
  background-color: rgba(0, 0, 0, 0.5);
  opacity: ${(props) => props.open ? 1 : 0};
  pointer-events: ${(props) => props.open ? 'auto' : 'none'};
  transition: opacity 150ms linear;
`;

export const Header = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding-bottom: ${H_PADDING_MOBILE};
`;

export const Heading = styled(UnstyledHeading)`
  color: ${colors.B500};
`;

export const Inner = styled.div`
  position: absolute;
  top: 0;
  right: 40px;
  bottom: 0;
  left: 0;
  padding: ${H_PADDING_MOBILE};
  background-color: ${colors.N0};
  transform: translateX(${(props) => props.open ? 0 : '-100%'});
  transition: transform 200ms ease;
  overflow-y: auto;
`;

export const Item = styled.div`
  &:first-of-type {
    margin-top: 8px;
  }

  &:not(:last-child) {
    margin-bottom: 8px;
  }
`;

export const Search = styled.div`
  position: relative;
  border-top: 3px solid ${colors.B100};
  border-bottom: 3px solid ${colors.B100};
`;

export const SearchButton = styled.button`
  position: absolute;
  top: 0;
  bottom: 0;
  right: 0;
  margin: auto 0;
  display: flex;
  align-items: center;
  height: 20px;
  width: 20px;
  background: transparent;
  border: 0;
  padding: 0;
  appearance: none;
  cursor: pointer;
  outline: 0;
`;

export const SearchInput = styled.input`
  padding: 16px 0;
  width: 100%;
  color: ${colors.B500};
  font-family: ${props => fonts(props.theme.locale).SANS_CONDENSED};
  font-size: 20px;
  font-weight: ${weights.BOLD};
  line-height: 120%;
  border: 0;
  outline: 0;

  &::placeholder {
    color: ${colors.B200};
  }
`;

export const Section = styled.div`
  padding: 16px 0;
  border-bottom: 3px solid ${colors.B100};
`;

export const Wrapper = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  border-top: 3px solid ${colors.B100};
  border-bottom: 3px solid ${colors.B100};
  padding: 16px 0;
`;
